import { render, staticRenderFns } from "./r-item-container-mode.vue?vue&type=template&id=dbdc7726"
import script from "./r-item-container-mode.vue?vue&type=script&lang=js"
export * from "./r-item-container-mode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbdc7726')) {
      api.createRecord('dbdc7726', component.options)
    } else {
      api.reload('dbdc7726', component.options)
    }
    module.hot.accept("./r-item-container-mode.vue?vue&type=template&id=dbdc7726", function () {
      api.rerender('dbdc7726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-container-mode.vue"
export default component.exports